/* eslint-disable no-unused-vars */
import Contact from "../../components/Contact"
import Experience from "../../components/Experience"
import CarouserExperient from "../../components/Experience"
import Footer from "../../components/Footer"
import HeroPage from "../../components/HeroPage"
import TabPortofolio from "../../components/projects/project_tab"
import Service from "../../components/service"

const Homepage = () => {
  return (
    <>
      <HeroPage />
      <Service />
      <TabPortofolio />
      {/* <Experience /> */}
      <Contact />
      <Footer />
    </>
  )
}

export default Homepage